import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { getLoginPath } from '@/utils/localePaths';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const { t, locale } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-[#FFDD59] animate-spin mx-auto mb-4" />
          <p className="text-gray-400">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // LOCALE-AWARE: kok-sabit "/login" TR kullaniciyi /en/login'e dusuruyordu (App.js:410).
    //   getLoginPath(locale) = PendingReportsPage:34 ile AYNI util (tr->/tr/giris, else /{l}/login).
    return <Navigate to={getLoginPath(locale)} replace />;
  }

  return children;
}

export default ProtectedRoute;
